import React from 'react';
import Slider from 'react-slick';
import imgArray from '../images/slider/imgArray';
import Arrow from './Arrow';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { TextBlock } from './styles/Photos';
import GiftCertificate from '../images/gift_certificate.jpg';
function Photos() {
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: 50,
    nextArrow: <Arrow width={50} height={50} />,
    prevArrow: <Arrow left width={50} height={50} />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div id="photos">
        <h1 style={{ textAlign: 'center' }}>Photos</h1>
        <Slider {...sliderSettings}>{imgArray}</Slider>
      </div>
      <TextBlock>
        <p>Gift certificate available.</p>
        <p>Please call the restaurant to purchase</p>
        <img src={GiftCertificate} alt="gift certificate" />
      </TextBlock>
    </>
  );
}

export default Photos;
